module.exports = __webpack_public_path__ + "img/QOOKER_Box09.baef0d4f.jpg";